export class Work {
    image: string|undefined;
    image_width: number|undefined;
    image_height: number|undefined;
    image_preview: string|undefined;
    image_preview_width: number|undefined;
    image_preview_height: number|undefined;
    image_preview_mobile: string|undefined;
    image_preview_mobile_width: number|undefined;
    image_preview_mobile_height: number|undefined;
    title: string;
    description: string;
    url: string;
  
    constructor(title: string, description: string, url: string) {
      this.title = title;
      this.description = description;
      this.url = url;
    }

    addImage(image: string, width: number, height: number) {
      this.image = image;
      this.image_width = width;
      this.image_height = height; 
    }

    addPreviewImage(image_preview: string, width: number, height: number) {
        this.image_preview = image_preview;
        this.image_preview_width = width;
        this.image_preview_height = height;
    }

    addPreviewMobileImage(image_mobile: string, width: number, height: number) {
      this.image_preview_mobile = image_mobile;
      this.image_preview_mobile_width = width;
      this.image_preview_mobile_height = height;
    }
  }
  